import { useMutation, useQuery } from '@tanstack/react-query';

import {
  BusinessManagerRequester,
  type ProductListDto,
  type SendUpdateUpsellDto,
  type SendUpdateUpsellResponseDto,
  type SendUpsellCalculationDto,
  type SendUpsellCalculationResponseDto,
  type SendUpsellDto,
  type SendUpsellResponseDto,
  type UpsellCompanyDataResponseDto,
} from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

import Alert from '@cobliteam/ui/components/Alert';

export const UPSELL_MODAL = 'UPSELL_MODAL';
export const UPSELL_MODAL_PRODUCT_LIST_QUERY_KEY = 'SCHEDULE_PRODUCT_LIST';
export const UPSELL_MODAL_COMPANY_DATA_QUERY_KEY = 'SCHEDULE_UPSELL_COMPANY_DATA';

const env = Environment.getInstance().getEnvironment();
const businessManagerRequester = new BusinessManagerRequester({
  host: env.apiEfopBusinessManager,
});

const useUpsellModal = () => {
  const getCompanyUpsellData = (companyId: string) => {
    return useQuery<UpsellCompanyDataResponseDto>({
      queryKey: [UPSELL_MODAL, UPSELL_MODAL_COMPANY_DATA_QUERY_KEY],
      queryFn: () => businessManagerRequester.getCompanyUpsellData(companyId),
      enabled: !!companyId,
    });
  };
  const useSendUpsell = () => {
    return useMutation<SendUpsellResponseDto, unknown, SendUpsellDto>({
      mutationFn: async (deal) => businessManagerRequester.sendUpsell(deal),
      onError: () => Alert.error('Falha ao enviar pedido de upsell.'),
    });
  };
  const useGetUpsellCalculation = () => {
    return useMutation<SendUpsellCalculationResponseDto, unknown, SendUpsellCalculationDto>({
      mutationFn: async (calculation) => businessManagerRequester.getUpsellCalculation(calculation),
      onError: () => Alert.error('Falha ao enviar pedido de upsell.'),
    });
  };
  const useUpdateStageUpsell = () => {
    return useMutation<SendUpdateUpsellResponseDto, unknown, SendUpdateUpsellDto>({
      mutationFn: async (upsellStage) => businessManagerRequester.updateStageUpsell(upsellStage),
      onError: () => Alert.error('Falha ao enviar pedido de upsell.'),
    });
  };
  const getProductList = () => {
    return useQuery<ProductListDto>({
      queryKey: [UPSELL_MODAL, UPSELL_MODAL_PRODUCT_LIST_QUERY_KEY],
      queryFn: () => businessManagerRequester.getProductList(),
    });
  };

  return {
    useSendUpsell,
    getCompanyUpsellData,
    getProductList,
    useGetUpsellCalculation,
    useUpdateStageUpsell,
  };
};
export default useUpsellModal;
